/**
 * Host ↔ Iframe messaging contract — version + shared constants (host side).
 *
 * Canonical spec (owned by performx-ruleset-builder):
 *   docs/IFRAME_MESSAGING_CONTRACT.md
 *
 * Versioning: a semver string. The host and builder are compatible IFF their
 * MAJOR versions match. Bump MAJOR only on a breaking change to the message set
 * or payload shapes; bump MINOR/PATCH for backwards-compatible additions. The
 * check runs once, at the ready↔init handshake (see RuleSetBuilderIframe.vue).
 *
 * Keep PROTOCOL_VERSION and the message-type constants in sync with the builder
 * repo's iframe-host/messagingContract.ts and the canonical doc above.
 */
export const PROTOCOL_VERSION = "1.3.0";

/** Messages the host sends to the builder. */
export const HOST_TO_BUILDER = {
  INIT: "rsb:init",
  UPDATE_TOKEN: "rsb:update-token",
  UPDATE_PROPS: "rsb:update-props",
  SET_METADATA: "rsb:set-metadata",
  GET_STATE: "rsb:get-state",
  SAVE: "rsb:save",
};

/** Messages the builder sends to the host. */
export const BUILDER_TO_HOST = {
  READY: "rsb:ready",
  RESIZE: "rsb:resize",
  STATE: "rsb:state",
  SAVE_RESULT: "rsb:save-result",
  EVENT: "rsb:event",
  ERROR: "rsb:error",
};

/** Parse the MAJOR component of a semver string; null if missing/unparseable. */
export function protocolMajor(version) {
  const major = parseInt(String(version ?? "").split(".")[0], 10);
  return Number.isNaN(major) ? null : major;
}

/**
 * True when peerVersion shares localVersion's MAJOR. A missing/unparseable peer
 * version is treated as incompatible (fail loud) — this also rejects an
 * un-versioned legacy peer, which is the intended strict behaviour.
 */
export function isMajorCompatible(peerVersion, localVersion = PROTOCOL_VERSION) {
  const a = protocolMajor(peerVersion);
  const b = protocolMajor(localVersion);
  return a !== null && b !== null && a === b;
}
